import React from 'react';
import { bool, func, node, object } from 'prop-types';
import { connect } from 'react-redux';

import SnapaskHeader from '@dragonfruit/components/SnapaskHeader';
import SnapaskFooter from '@dragonfruit/components/SnapaskFooter';
import SnapaskLocaleSelection from '@dragonfruit/components/SnapaskLocaleSelection';

import AlertBannerHandler from '@dragonfruit/containers/AlertBannerHandler';
import AlertModalHandler from '@dragonfruit/containers/AlertModalHandler';
import TermsDialogHandler from '@dragonfruit/containers/TermsDialogHandler';
import SocialWidgetHandler from '@dragonfruit/containers/SocialWidgetHandler';

import {
  hideAlertModal,
  getAlertModalVisible,
  getAlertModalProps,
} from '@dragonfruit/redux/alertModal';

import './MainLayout.scss';
import '@snapask/common-components/dist/css/common.css';

const MainLayout = ({
  children,
  showHeader,
  showFooter,
  hideAlertModal,
  showAlertModal,
  alertModalProps,
}) => {
  return (
    <div>
      {showHeader && <SnapaskHeader />}
      <AlertBannerHandler />
      {showAlertModal && (
        <AlertModalHandler {...alertModalProps} onClose={hideAlertModal} />
      )}
      <SnapaskLocaleSelection />
      <TermsDialogHandler />
      {children}
      {showFooter && <SnapaskFooter />}
      <SocialWidgetHandler />
    </div>
  );
};

MainLayout.propTypes = {
  children: node.isRequired,
  alertModalProps: object,
  hideAlertModal: func,
  showAlertModal: bool,
  showFooter: bool,
  showHeader: bool,
};

MainLayout.defaultProps = {
  alertModalProps: {},
  showAlertModal: false,
  showHeader: true,
  showFooter: false,
  hideAlertModal: () => {},
};

export default connect(
  state => ({
    showAlertModal: getAlertModalVisible(state),
    alertModalProps: getAlertModalProps(state),
  }),
  {
    hideAlertModal,
  }
)(MainLayout);



// WEBPACK FOOTER //
// ./app/layouts/MainLayout/MainLayout.jsx